// extracted by mini-css-extract-plugin
export var container = "_co-0";
export var icon = "_co-1";
export var text = "_co-2";